import Component from 'ShopUi/models/component';

export default class CallbackForm extends Component {
    private contactForm: HTMLFormElement;
    private callbackPhone: HTMLInputElement;
    private callbackTimeStartHourInput: HTMLInputElement;
    private callbackTimeEndHourInput: HTMLInputElement;
    private callbackInfoBox: HTMLElement;

    protected init(): void {
        this.contactForm = this.closest('[name="contactForm"]');
        this.callbackPhone = this.querySelector('#contactForm_callback_callback-method_1');
        this.callbackTimeStartHourInput = this.querySelector('#contactForm_callback_callback-method-via-phone_callbackTimeStart_hour');
        this.callbackTimeEndHourInput = this.querySelector('#contactForm_callback_callback-method-via-phone_callbackTimeEnd_hour');
        this.callbackInfoBox = this.querySelector('.callback-info-box');

        this.addFieldEventListener();
    }

    protected readyCallback(): void {
    }

    private readonly addFieldEventListener = (): void => {
        this.contactForm.addEventListener('submit', this.checkCallbackTime);
    }

    private readonly checkCallbackTime = (event: Event): void => {
        this.hideError();

        const startDate = new Date();
        startDate.setHours(parseInt(this.callbackTimeStartHourInput.value), 0, 0);
        const endDate = new Date();
        endDate.setHours(parseInt(this.callbackTimeEndHourInput.value), 0, 0);

        if (this.callbackPhone.checked &&
            !(startDate.getTime() < endDate.getTime())
        ) {
            this.displayError();
            event.preventDefault();
        }
    }

    private readonly displayError = () => {
        this.callbackInfoBox.classList.remove('hide');
    }

    private readonly hideError = () => {
        this.callbackInfoBox.classList.add('hide');
    }
}
